angular.module('bmsApp.trugreen.bulkPriceUpdate').controller('TGBulkPriceUpdateCtrl',
    function ($state,
              $scope,
              $q,
              notify,
              TGTreatmentSvc,
              TaxHelperSvc,
              TGBulkPriceUpdateSvc,
							AppSettingsSvc
    ) {

        let self = this;

        $scope.options = {};
        $scope.loading = true;
        $scope.currentStep = 'price-form';
        $scope.processing = false;
        $scope.processed = false;

        this.$onInit = () => {
            var promises = {
                setVatRate: TaxHelperSvc.setVatRate(),
                treatmentOptions: TGTreatmentSvc.options({withPrices: true}),
								appSettings: AppSettingsSvc.index()
            };
            return $q.all(promises)
                .then(function (responses) {
                    $scope.treatments = [];
                    angular.forEach(responses.treatmentOptions.data.options, (treatment) => {
                        angular.forEach(treatment.prices, (price, index) => {
                            treatment.prices[index] = {
                                area_in_m2: price.area_in_m2,
                                rrp: TaxHelperSvc.grossFromNet(price.rrp),
                                custom_rrp: TaxHelperSvc.grossFromNet(price.rrp),
                            };
                        });

                        $scope.treatments.push({
                            id: treatment.id,
                            name: treatment.name,
                            update_method: 'matrix-price',
                            selected: false,
                            prices: treatment.prices,
                        });
												$scope.appSettings = responses.appSettings.data.settings;
                    });
                    $scope.loading = false;
                });
        };

        $scope.preview = function (confirmed) {
            $scope.errors = [];
            $scope.processing = true;

            const params = {
                treatments: [],
            }
            angular.forEach($scope.treatments, (treatment) => {
                if (treatment.selected) {
                    params.treatments.push(treatment);
                }
            });
            if(!params.treatments.length){
                $scope.errors = ['Please select one or more treatments'];
                $scope.processing = false;
                return;
            }

            if(confirmed){
                params.confirmed = true;
            }
            $scope.processingPromise = TGBulkPriceUpdateSvc.preview(params).then(function (response) {
                if(!confirmed && response.data.quotes.length == 0){
                    notify({
                        message: 'No matching quotes found'
                    });
                    return;
                }
                $scope.currentStep = 'preview';
                if(!confirmed){
                    $scope.quotes = response.data.quotes;
                }
                $scope.processing = false;
                if(confirmed){
                    $scope.processed = true;
                    notify({
                        message: 'Pricing updated successfully'
                    });
                }

            });
        }

        $scope.back = function () {
            $scope.processed = false;
            $scope.currentStep = 'price-form';
        }
    });
